import React, { useState, useContext } from 'react';
import { ShopperContext } from '../context/shopper'
import { useUtils } from "../hooks/useUtils";
import { usePhrasing } from "../hooks/useSkuUtils";
import { useStyles } from "../hooks/useStyles";
import CircleInvitations from './CircleInvitations';
import InvitationForm from '../components/InvitationForm'
import CircleShopperRow from '../components/CircleShopperRow'
import { ErrorList } from '../components/ErrorList';
import Checkbox from '../components/Checkbox';
import HeadingBuilder from '../components/HeadingBuilder';
import * as Constants from '../constants';
import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";

const CircleShoppers = ({circle_id, circle_identifier, circle_leader_id,
  open_invites, accepted_invites, topOfInvitesRef}) => {
  console.log('c_id_prop', circle_id);
  console.log('c_identifier_prop', circle_identifier);
  console.log('c_invites', open_invites);
  console.log('c_accepted_invites', accepted_invites);

  const { shopper, signedIn, errorsDoExist, circles, circleShoppers } = useContext(ShopperContext);
  console.log('cs_circleShoppers', circleShoppers);  // TODO: this will soon dump too much data...

  const [invitationFormFlag, setInvitationFormFlag] = useState(false);
  const lightUpAddInvitationButton = () => {
      setInvitationFormFlag(false);
  }

  const [showRemoveShopperColumn, setShowRemoveShopperColumn] = useState(false);
  const toggleShowRemoveShopperColumn = () => {
      setShowRemoveShopperColumn(prev => !prev);
      console.log("srsc", showRemoveShopperColumn);
  };

  const [justMadeInvite, setJustMadeInvite] = useState(false);
  const [invitee, setInvitee] = useState('');
  const passInvitee = (inviteeFromForm) => {
    setInvitee(inviteeFromForm);
  };

  const { tableShow, textAlignLeft } = useStyles();
  const { is_shopper_a_circle_admin } = useUtils();
  const { t } = useTranslation();

  const { getMaxCapacityTippyContent } = usePhrasing();

  if (signedIn) {
      // Is current_shopper an admin for the current circle?
      // TODO: Hmm, reaching outside of function for value of 'circle_id' and 'shopper'
      const if_shopper_is_circle_admin = is_shopper_a_circle_admin({
        cShoppers: circleShoppers, circle_id: circle_id, shopper_id: shopper.id
      });
      console.log('cs isica if_shopper_is_circle_admin', if_shopper_is_circle_admin);

      const circle = circles.find(c => c.id == circle_id);
      const if_shopper_is_circle_leader =  shopper.id === circle_leader_id;

      const atMaxCapacityTippyContent =
        getMaxCapacityTippyContent ({
          hasOpenInvites:    circle.open_invites.length > 0,
          hasReachedMaxPlan: circle.max_shoppers == circle.slots_used
        })

      const labelToStartShowing =
        if_shopper_is_circle_leader
          ? t('circleShopper.removeShopper.toggleButtonPermitsLabel')
          : t('circleShopper.leaveCircle.toggleButtonPermitsLabel');

      const tippyTextForStartShowing =
        if_shopper_is_circle_leader
          ? t('circleShopper.removeShopper.qRemoveShopperFromCircleTippyText') +
            t('global.clickCheckboxToShowHideColumnTippyText')
          : t('circleShopper.leaveCircle.toggleButtonPermitsTippyText') +
            t('global.clickCheckboxToShowHideColumnTippyText') +
            t('circleShopper.leaveCircle.toggleButtonWarningTippyText') +
            t('global.qWantToProceedTippyText');

      const labelToStopShowing =
        if_shopper_is_circle_leader
          ? t('circleShopper.removeShopper.toggleButtonDisablesLabel')
          : t('circleShopper.leaveCircle.toggleButtonDisablesLabel');

      const tippyTextForStopShowing =
        if_shopper_is_circle_leader
          ? t('circleShopper.removeShopper.toggleButtonDisablesTippyText')
          : t('circleShopper.leaveCircle.toggleButtonDisablesTippyText');

      const tippyTextForStartOrStopShowing =
  showRemoveShopperColumn ? tippyTextForStopShowing : tippyTextForStartShowing;

      const removeShopperColumnHeading =
        if_shopper_is_circle_leader
          ? t('circleShopper.removeShopper.columnLabel')
          : t('circleShopper.leaveCircle.columnLabel');

      const topOffColumnHeading = t('circleShopper.formPart.topOffLabel');

      // The '(i)' text ends with a conclusion that depends on the level.
      // At 100% there is no gap to make up, so the sentence about raising
      // orders would describe something that cannot happen.
      const topOffConclusionKey =
        circle.topoff_level == 100
          ? 'circleShopper.formPart.topOffTippyConclusion100'
          : 'circleShopper.formPart.topOffTippyConclusion';

      // Both header tooltips name the feature, and the '(i)' one also
      // quotes this circle's own threshold rather than a generic phrase.
      const topOffColumnTippyValues = {
        topoff_label:       topOffColumnHeading,
        topoff_level_label: t('circle.topoff.label'),
        topoff_level:       circle.topoff_level,
        // The '!' text points at this column's own 'no' value, so it
        // reads as whatever the yes/no cells below actually say.
        no_label:           t('global.label.noLc'),

        // Resolved by its own 't()' rather than injected raw: i18next
        // does not re-interpolate the values it substitutes, so the
        // '{{topoff_label}}' inside the conclusion has to be expanded
        // here. Injecting the untranslated key's text would print the
        // braces literally.
        topoff_conclusion:  t(topOffConclusionKey,
                              { topoff_label: topOffColumnHeading,
                                topoff_level: circle.topoff_level,
                                topoff_level_label: t('circle.topoff.label'),
                               }),
      };

      const removeShopperColumnTippyContent =
        if_shopper_is_circle_leader
          ? t('circleShopper.removeShopper.qRemoveShopperFromCircleTippyText') +
            t('global.removeWarning') +
            t('circleShopper.removeShopper.columnHeaderTippyContent') +
            t('circleShopper.removeShopper.tippyContent2')
          : t('circleShopper.leaveCircle.tippyContent1') +
            t('global.removeWarning') +
            t('circleShopper.leaveCircle.columnHeaderTippyContent') +
            t('circleShopper.leaveCircle.tippyContent2');

      console.log('isicl if_shopper_is_circle_leader', if_shopper_is_circle_leader);
      console.log('c_id', circle_id);
      const circleShoppersList =
        circleShoppers.filter(cs => cs.circle_id==circle_id)
                      .map(cs => <CircleShopperRow
                             key={cs.id}
                             cs={cs}
                             if_shopper_is_circle_admin={if_shopper_is_circle_admin}
                             if_shopper_is_circle_leader={if_shopper_is_circle_leader}
                            //  admin_id={shopper.id}
                             cShopper={JSON.stringify(cs.shopper)}
                             circle_id={cs.circle_id}
                             circle_identifier={circle_identifier}
                             circle_leader_id={circle_leader_id}
                             invitation={accepted_invites.find(i => i.invitee == cs.shopper.identifier) || open_invites.find(i => i.invitee == cs.shopper.identifier)}
                             showRemoveShopperColumn={showRemoveShopperColumn}
                          />
                      )
      // Invitation needs two finds: the invitation likely has status 'Accepted',
      // but maybe shopper changed the status to 'Rejected' or 'Improper' after
      // they accepted.
      // Hmm, as of 231123 (and earlier), status of 'Accepted' can't be changed.
      console.log('CShoppersList', circleShoppersList);

      const successTellInviteeMsg = 
          t('circleShopper.inviteShopperButton.warningForSubmit10')
          // You have invited '
        + invitee
          // alice
        + t('circleShopper.inviteShopperButton.warningForSubmit30');
          // ' to join your circle! Contact them and tell them you have created an invitation.

      const inviteShopperButtonLabel =
        t('circleShopper.inviteShopperButton.label');

      const inviteShopperButtonTippy =
        t('circleShopper.inviteShopperButton.tippyContent');

      const atMaxCapacityWarning =
        t('circleShopper.inviteShopperButton.atMaxCapacityWarning');

      return (
          <div>
              <HeadingBuilder
                Size = 'h3'
                headingText = {t('circleShopper.formPart.headlineLabel')}
                // Circle Shoppers
                tippyAlertText = {t('circleShopper.formPart.headlineTippyContent')}
                tippyText = {t('circleShopper.formPart.headlineTippyContent')}
              />
              <HeadingBuilder
                Size = 'h5'
                headingText = {t('circleShopper.formPart.in')}
                // in
                value = {circle_identifier}
              />
              <Table striped bordered hover style={tableShow}>
                <thead style={textAlignLeft}>
                  <tr>
                    {/* Shortname / Name / Admin / Top Off */}
                    <th>
                      <HeadingBuilder
                        containerType  = "container-left"
                        headingText    = {t('shopper.shortname.label')}
                        // Shortname
                        tippyAlertText =
                            {t('circleShopper.formPart.shortnameTippyContent')}
                        tippyText      = {Constants.DOT}
                      />
                    </th>
                    
                    <th>{t('circleShopper.formPart.nameLabel')}</th>
                    <th>{t('circleShopper.formPart.adminLabel')}</th>

                    <th>
                      <HeadingBuilder
                        containerType  = "container-left"
                        headingText    = {topOffColumnHeading}
                        // Top Off
                        tippyAlertText = {t(
                          'circleShopper.formPart.topOffTippyContent',
                          topOffColumnTippyValues
                        )}
                        tippyText      = {Constants.DOT}
                        tippyInfoText  = {t(
                          'circleShopper.formPart.topOffTippyInfo',
                          topOffColumnTippyValues
                        )}
                      />
                    </th>

                    <th>
                      { showRemoveShopperColumn
                        ? <HeadingBuilder
                            containerType  = "container-left"
                            headingText    = {removeShopperColumnHeading}
                            // Leave Circle? | Remove Shopper?
                            tippyAlertText = {removeShopperColumnTippyContent}
                            tippyText      = {removeShopperColumnTippyContent}
                          />
                        : null
                      }
                    </th>
                  </tr>
                </thead>
                <tbody style={textAlignLeft}>
                  {circleShoppersList}
                </tbody>
              </Table>
              { errorsDoExist && <ErrorList /> }
              { circleShoppersList.length > 1
                // Don't show button if Leader is only one in the list.
                // Can't remove self from circle if self is Leader, and
                // Leader is guaranteed to be in the list.
                // So, need others to be in the list to show the button.
                // (Every circle has a leader so need qty of more than one to
                // know that someone there is not the leader.)
                ? <Checkbox
                    isChecked={showRemoveShopperColumn}
                    setIsChecked={toggleShowRemoveShopperColumn}
                    label={showRemoveShopperColumn
                      ? labelToStopShowing
                      // Show ['Remove a Shopper'|'Leave the Circle'] column?
                      : labelToStartShowing
                      // Leave the Circle | Remove a Shopper
                    }
                    tippyAlert={tippyTextForStartOrStopShowing}
                  />
                : null
              }
              <article ref={topOfInvitesRef} tabIndex="-1">
                <hr />
                { circle.open_invites.length > 0
                  ? <CircleInvitations
                      circle_id={circle.id}
                      circle_identifier={circle.identifier}
                      circle_leader_id={circle.leader_id}
                      open_invites={open_invites}
                    />
                  : <>&nbsp;</>
        // Wacky: Using ternary to present this component at least gets the
        // headline "Outstanding Invitations" to appear if focus on the ref
        // after inviting an admin to become leader of the circle. The whole
        // component seems to appear if there is already an invitation.
        // Using short-circuit '&&' approach means headline does not appear
        // if no outstanding invitations. But the whole component is visible
        // after 'focus' if there was already an invitation.
        // Ideally the whole 'Outstanding Invitations' componenent would
        // show (focus) at the top of the page regardless of prior invitations.
                }
              </article>
              {invitationFormFlag
                ? <InvitationForm
                  circle_id={circle_id}
                  circle_identifier={circle_identifier}
                  setJustMadeInvite={setJustMadeInvite}
                  passInvitee={passInvitee}
                  lightUpAddInvitationButton={lightUpAddInvitationButton} />
                : ((if_shopper_is_circle_admin && circle.is_current)
                  ? ((circle.slots_used < circle.max_shoppers || justMadeInvite)
                    // If haven't hit 'max_shoppers' limit, then ok to invite.
                    // If 'justMadeInvite', there had to be capacity to invite,
                    // so show the reminder to contact the shopper re invite.
                    // But, do we allow admin to invite even more shoppers?
                    ? (circle.slots_used === circle.max_shoppers
                      // then 'slots_used' < 'max_shoppers' wasn't the condition
                      // that got us here. It had to be 'justMadeInvite'.
                      // If 'justMadeInvite', it's good to remind admin to tell
                      // the invitee about their new invitation to join Circle.
                      // But, if 'slots_used' has reached 'max_shoppers' limit,
                      // there is no capacity for more shoppers, so don't show a
                      // message or buttons encouraging new invitations.
                      // Instead, show a message about 'no capacity'.
                      ? <HeadingBuilder
                          headingText    = {atMaxCapacityWarning}
                        //Circle is at max capacity of Shoppers and open Invites
                          tippyAlertText = {atMaxCapacityTippyContent}
                          tippyText      = {Constants.DOT}

                          forceShowBWarning = {justMadeInvite}
                          setShowBWarning   = {setJustMadeInvite}
                          bWarningMsg       = {successTellInviteeMsg}
                          // You have invited 'alice' to join your circle! Contact them and tell them you have created an invitation.
                        />

                      : <HeadingBuilder
                          headingText    = {inviteShopperButtonLabel}
                        // Invite a Shopper to the Circle (requires admin)
                        buttonAction   = {() => setInvitationFormFlag(true)}
                        goButtonText   = {Constants.GET_ICON_RT_ARROW}
            
                          tippyAlertText = {inviteShopperButtonTippy}
                          tippyText      = {Constants.DOT}

                        forceShowBWarning = {justMadeInvite}
                        setShowBWarning   = {setJustMadeInvite}
                        bWarningMsg       = {successTellInviteeMsg}
                        // You have invited 'alice' to join your circle! Contact them and tell them you have created an invitation.
                        />
                      )

                    : <HeadingBuilder
                        headingText    = {atMaxCapacityWarning}
                        // Circle is at max capacity of Shoppers and open Invites
                        tippyAlertText = {atMaxCapacityTippyContent}
                        tippyText      = {Constants.DOT}
                      />
                    )

                  : null  // i.e. not an admin, or else circle is not current
                  )
              }
              <br/>
          </div>
      )
  } else {
    return (
      <HeadingBuilder
        Size = 'h3'
        headingText = {t('global.notSignedInMessage')}
        // Not Authorized - Please Sign in or Sign up
      />
    )
  }
}

export default CircleShoppers;
